import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { isVelthuis } from '@/utils/common.ts'

import { router as velthuisRouter } from './velthuis.router.tsx'
import { router as xpertRouter } from './xpert.router.tsx'

const router = createBrowserRouter(isVelthuis ? velthuisRouter : xpertRouter)
const RouterRoot = () => {
  return <RouterProvider router={router} />
}

export default RouterRoot
